export enum ModuleName {
  Cloud = 1,
  Construct = 2,
  DefaultCloud = 3,
  AICloud = 4,
  DefaultConstruct = 8,
  AIConstruct = 9,
}
